(function () {
  function scrollToReviews(e) {
    var widget = document.querySelector('.jm-review-widget');
    if (!widget) return;
    if (e) e.preventDefault();
    widget.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  /* 1. Link #recensioni messi a mano (se presenti) */
  document.addEventListener('click', function (e) {
    if (e.target.closest('a[href$="#recensioni"]')) scrollToReviews(e);
  });

  /* 2. Stelle ⭐⭐⭐⭐⭐ nei blocchi Testo: cliccabili senza link */
  var STARS = /(\u2B50\uFE0F?){5}/;
  var main = document.getElementById('main') || document.body;
  var walker = document.createTreeWalker(main, NodeFilter.SHOW_TEXT, {
    acceptNode: function (n) {
      if (!STARS.test(n.nodeValue)) return NodeFilter.FILTER_SKIP;
      if (n.parentElement.closest('a, .jm-review-widget')) return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }
  });
  var node;
  while ((node = walker.nextNode())) {
    var el = node.parentElement;
    if (el.dataset.lpsStars) continue;
    el.dataset.lpsStars = '1';
    el.style.cursor = 'pointer';
    el.setAttribute('role', 'link');
    el.setAttribute('tabindex', '0');
    el.addEventListener('click', scrollToReviews);
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') scrollToReviews(e);
    });
  }

  /* 3. Stelle accanto alla media: legge il voto mostrato dal widget */
  function applyAvg() {
    var el = document.querySelector('.jm-review-widget .jm-average-rating-display .jm-cluster > p');
    if (!el) return false;
    var rating = parseFloat(el.textContent.replace(',', '.'));
    if (!rating) return true;
    var full = Math.floor(rating);
    var fill = full * 24 + (rating - full) * 20;
    var root = document.documentElement;
    root.style.setProperty('--lps-avg-display', 'inline-block');
    root.style.setProperty('--lps-avg-fill', fill.toFixed(1) + 'px');
    return true;
  }
  if (!applyAvg()) {
    var observer = new MutationObserver(function () {
      if (applyAvg()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();